import { skipToken, useQuery } from '@tanstack/react-query'
import type { ReturnsApiAvailableRefundMethodChangeOptionsRequest } from '@itsrever/rever-api'
import { getAvailableRefundMethods } from '@/api/returns-api'

export const useProcessAvailableRefundMethods = ({
  processId
}: Partial<ReturnsApiAvailableRefundMethodChangeOptionsRequest>) => {
  return useQuery({
    queryKey: ['process-available-refund-methods', processId],
    queryFn:
      processId !== undefined
        ? async () => {
            const response = await getAvailableRefundMethods({ processId })

            return response
          }
        : skipToken
  })
}
